export default "__VITE_ASSET__BpYKX93n__"